import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

export class SelfPickupsRequests {

  /* @ngInject */
  constructor(private selfPickupsAPI: BringozApi, private $selfPickups) {
  }

  createOne(selfPickup) {
    const api = this.selfPickupsAPI.actions.createOne;
    return this.$$call(api, {}, selfPickup, {});
  }

  updateOne(id, selfPickup) {
    const api = this.selfPickupsAPI.actions.updateOne;
    return this.$$call(api, {}, selfPickup, {id: id});
  }

  deleteOne(id) {
    const api = this.selfPickupsAPI.actions.deleteOne;
    return this.$$call(api, {}, {}, {id: id});
  }

  sendMessage(id) {
    const api = this.selfPickupsAPI.actions.sendMessage;
    return this.$$call(api, {}, {}, {id: id});
  }

  getTotals(depotId, from, to) {
    const api = this.selfPickupsAPI.actions.getTotals;
    return this.$$call(api, {depotId: depotId, from: from, to: to}, {}, {});
  }

  getTimelineLog(id, limit, cursor) {
    const api = this.selfPickupsAPI.actions.getTimelineLog;
    return this.$$call(api, {limit: limit, cursor: cursor}, {}, {id: id});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$selfPickups().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .service('selfPickupsRequests', SelfPickupsRequests);
